import { useEffect, useState } from 'react';
import { IDaypartRecord } from 'src/components/timeRow';
import { IAssembly, IDaypart } from 'src/interfaces';

import { useGetAllDayparts, useGetDefaultAssemblies } from './api';

export interface IDaypartsWithDefaultAssembly extends IDaypart {
  defaultAssembly: IAssembly[] | undefined;
}

export const useGetDefaultAssemblyOfDayparts = (
  locationGroupId: string,
  rbStoreIntegration: boolean,
  locationCode?: string,
  setInitialDaypartsRecord?: React.Dispatch<
    React.SetStateAction<IDaypartRecord[]>
  >,
) => {
  const [daypartsWithDefaultAssembly, setDaypartsWithDefaultAssembly] =
    useState<IDaypartsWithDefaultAssembly[]>([]);
  const {
    data: daypartOptions,
    isLoading: isLoadingDayparts,
    error: errorLoadingDayparts,
  } = useGetAllDayparts();
  const {
    data: defaultAssemblyData = [],
    isLoading: isLoadingDefaultAssemblies,
  } = useGetDefaultAssemblies(
    [
      `location_group_id=${locationGroupId}`,
      'sort=-modified_at',
      'is_expired=false',
    ],
    Boolean(locationGroupId),
    'timing',
    rbStoreIntegration,
  );

  useEffect(() => {
    if (daypartOptions) {
      const daypartTimes = daypartOptions.map((daypart) => {
        const findLocationGroupAssembly = defaultAssemblyData
          .filter((schedule) => schedule.daypart_id === daypart.id)
          .map((da) => {
            const assembly = da.assembly;

            return {
              ...assembly,
              startDate: da.start_date || null,
              validTo: da.valid_to,
              columnId: da.id,
            } as IAssembly;
          });

        return {
          ...daypart,
          defaultAssembly: findLocationGroupAssembly,
        };
      });

      setDaypartsWithDefaultAssembly(daypartTimes);
      setInitialDaypartsRecord && setInitialDaypartsRecord(daypartTimes);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [daypartOptions, defaultAssemblyData, locationCode]);

  return {
    daypartsWithDefaultAssembly,
    isLoadingDefaultAssemblies,
    isLoadingDayparts,
    errorLoadingDayparts,
    setDaypartsWithDefaultAssembly,
  };
};
